import React, { useEffect, useState } from "react";
import { tableUseStyle } from "../../etc/tableusestyle";
import { DataGridPremium } from "@mui/x-data-grid-premium";
import { Button, Input } from "@mui/joy";
import { getFetch, postFetch } from "../../../../../fetch/fetch";


const EducationVideoIpManager: React.FC<any> = (props) => {

    const classes = tableUseStyle();

    const [rows, setRows] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [ip, setIp] = useState<string>("");
    const [description, setDescription] = useState<string>("");

    const columns: any[] = [
        { field: "id", headerName: "ID", width: 80 },
        { field: "ip", headerName: "IP", width: 160 },
        { field: "description", headerName: "메모", width: 260, flex: 1 },
        { field: "teacherName", headerName: "등록자", width: 120 },
        {
            field: "createdAt",
            headerName: "등록일시",
            width: 200,
            renderCell: (params: any) => {
                if (!params.value) return "";
                const d = new Date(params.value);
                return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()} ${d.getHours()}:${String(d.getMinutes()).padStart(2, "0")}`;
            }
        },
        {
            field: "delete",
            headerName: "삭제",
            width: 100,
            sortable: false,
            renderCell: (params: any) => (
                <Button
                    size="sm"
                    variant="outlined"
                    color="danger"
                    onClick={() => handleDelete(params.row.id, params.row.ip)}
                >
                    삭제
                </Button>
            )
        }
    ];

    const fetchList = async () => {
        try {
            setLoading(true);
            const result: any = await getFetch("/dashboard/educationVideoIp/list");
            if (result.message === "success" && Array.isArray(result.data)) {
                setRows(result.data);
            } else {
                console.log(result);
            }
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchList();
    }, []);

    const handleAdd = async () => {
        const trimmedIp = ip.trim();
        if (!trimmedIp) {
            alert("IP를 입력해주세요.");
            return;
        }
        try {
            const result: any = await postFetch("/dashboard/educationVideoIp/add", {
                ip: trimmedIp,
                description: description.trim()
            });
            if (result.message === "success") {
                setIp("");
                setDescription("");
                fetchList();
            } else if (result.message === "duplicateIp") {
                alert("이미 등록된 IP 입니다.");
            } else if (result.message === "invalidIp") {
                alert("IP 형식이 올바르지 않습니다. (예: 59.10.30.212)");
            } else {
                alert(`등록 실패: ${result.message}`);
            }
        } catch (e) {
            console.log(e);
            alert("등록 중 오류가 발생했습니다.");
        }
    };

    const handleDelete = async (id: number, ipText: string) => {
        if (!window.confirm(`${ipText} 을(를) 삭제할까요?`)) return;
        try {
            const result: any = await postFetch("/dashboard/educationVideoIp/delete", { id });
            if (result.message === "success") {
                fetchList();
            } else {
                alert(`삭제 실패: ${result.message}`);
            }
        } catch (e) {
            console.log(e);
            alert("삭제 중 오류가 발생했습니다.");
        }
    };

    return (
        <div style={{ width: "96%" }}>
            <div style={{
                fontFamily: "Apple_B",
                marginTop: "50px",
                fontSize: "18px",
                display: "flex",
                alignItems: "center",
            }}>
                <div style={{ marginRight: "18px" }}>
                    교육영상 IP 관리
                </div>
            </div>

            <div style={{
                marginTop: "24px",
                display: "flex",
                gap: "12px",
                alignItems: "center",
                marginBottom: "16px",
            }}>
                <Input
                    size="md"
                    placeholder="IP (예: 59.10.30.212)"
                    value={ip}
                    onChange={(e) => setIp(e.target.value)}
                    sx={{ width: 220 }}
                />
                <Input
                    size="md"
                    placeholder="메모 (선택)"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    sx={{ width: 320 }}
                />
                <Button size="md" onClick={handleAdd}>
                    추가
                </Button>
            </div>

            <div className={classes.root} style={{ height: "500px", width: "100%" }}>
                <DataGridPremium
                    rows={rows}
                    columns={columns}
                    density="compact"
                    loading={loading}
                    hideFooter
                    disableRowSelectionOnClick
                />
            </div>
        </div>
    );
};

export default EducationVideoIpManager;
